import React, { Fragment } from 'react';
import {
    Button,
    Segment,
    Table,
    Form,
    Loader,
    Tab,
    Responsive,
    Popup,
    Message,
    Icon,
    Label,
    Grid, Divider, Header
} from 'semantic-ui-react';
import axios from 'axios';
import moment, { now } from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import Positions from './Positions';
import { Redirect } from 'react-router-dom';
import request from '../../../util/request';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class Employment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            person: {},
            employee: {},
            currentEl: null,

            data: [],
            showPositions: false,
            showPositionsMain: false,
            addNewEmployment: false,

            employment: null,
            otherEmployment: null,
            editEmployment: false,
            editOtherEmployment: false,
            main: null,

            orgUnits: [],
            dateEnd: null,
            dateStart: null,
            workTime: null,
            orgUnit: null,
            id: null,
            optLock: null,
            loading: true

        };

        this.getEmployments = this.getEmployments.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.editEmployment = this.editEmployment.bind(this);
        this.getPositions = this.getPositions.bind(this);
        this.getPositionsMain = this.getPositionsMain.bind(this);
        this.addNewEmployment = this.addNewEmployment.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.setState({
            person: JSON.parse(localStorage.getItem('person')),
            employee: JSON.parse(localStorage.getItem('employee')),
            main: localStorage.getItem('main') === 'true'
        });

        this.getEmployments();

        request.fetchOrgUnits()
            .then(orgUnits => this.setState({ orgUnits }));
    }


    getEmployments() {
        this.setState({ addNewEmployment: false });

        if (localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:') {
            let obj = {
                employee: {
                    id: JSON.parse(localStorage.getItem('employee')).id,
                    associateStaff: localStorage.getItem('associate') === 'true'
                },
                organizationalUnit: { id: parseInt(localStorage.getItem('orgUnitId')) }

            };

            axios.post('employees/employee-organizational-units/', { ...obj })
                .then(res => {
                    this.setState({ data: res.data, loading: false });
                })
                .catch(err => {
                    // toast('Provjera za osobu nije uspješno izvršena.');
                });
        } else {
            let obj = {
                id: JSON.parse(localStorage.getItem('employee')).id,
                associateStaff: localStorage.getItem('associate') === 'true'
            };

            axios.post('employees/employee-organizational-unit/', { ...obj })
                .then(res => {
                    this.setState({ data: res.data, loading: false });
                })
                .catch(err => {
                    // toast('Provjera za osobu nije uspješno izvršena.');
                });
        }
    }


    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    editEmployment() {
        let obj = {
            workTime: this.state.workTime,
            organizationalUnitId: this.state.orgUnit,
            dateEnd: this.state.dateEnd ? new Date(new Date(this.state.dateEnd).getFullYear(), new Date(this.state.dateEnd).getMonth(), new Date(this.state.dateEnd).getDate(), 0, 0, 0, 0) : null,
            dateStart: this.state.dateStart ? new Date(new Date(this.state.dateStart).getFullYear(), new Date(this.state.dateStart).getMonth(), new Date(this.state.dateStart).getDate(), 0, 0, 0, 0) : null,
            id: this.state.id,
            optLock: this.state.optLock
        };

        axios.put('employees/update-organizational-unit-employee', { ...obj })
            .then(res => {
                toast('Uspješno ste izvršili izmjenu zaposlenje.');
                this.setState({
                    optLock: null, id: null, orgUnit: null, employment: null, otherEmployment: null, editEmployment: false, editOtherEmployment: false, dateStart: null, dateEnd: null, workTime: null
                });
                this.getEmployments();
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena zaposlenja nije uspješno izvršena. Matična organizaciona jedinica možda već postoji.');
            });
    }

    changeMain(newMainOrgUnitId) {
        let currentMainOrgUnitId = this.state.data.filter(el => el.main)[0].organizationalUnit.id;

        axios.put(`hr/change-main/${JSON.parse(localStorage.getItem('employee')).id}/${currentMainOrgUnitId}/${newMainOrgUnitId}`)
            .then(res => {
                toast('Uspješno ste izvršili izmjenu matične organizacione jedinice.');
                this.setState({ redirect: true });
                // this.getEmployments();
            })
            .catch(err => {
                if (err.response.data === 'More than one main oue found!') {
                    toast('Pronađeno vise matičnih OJ. Javiti se administratoru za dalja uputstva.');
                } else if (err.response.data === 'No oue main found!') {
                    toast('Izmjena matične OJ nije moguća jer nije pronađena matična OJ');
                } else if (err.response.data === 'Passed main ou is not correct!') {
                    toast('Pogrešna trenutna matična OJ je poslana.');
                } else if (err.response.data === 'Organizational unit employee must be previously added!') {
                    toast('Ne postoji angažman za odabranu OJ.');
                } else if (err.response.data === 'Could not find organizational units with passed ids!') {
                    toast('Pogrešne informacije za OJ su poslane.');
                } else {
                    toast('Došlo je do greške! Nova matična organizaciona jedinica nije postavljena.');
                }
            });
    }

    getPositions(otherEmployment) {
        this.setState({
            otherEmployment, showPositions: true
        });
    }

    getPositionsMain(employment) {
        this.setState({
            employment, showPositionsMain: true
        });
    }

    addNewEmployment() {
        let obj = {
            main: false,
            organizationalUnitId: this.state.orgUnit,
            workTime: this.state.workTime,
            employeeId: JSON.parse(localStorage.getItem('employee')).id,
            dateStart: this.state.dateStart,
            dateEnd: this.state.dateEnd,
        };
        console.log('salje se: ', obj);
        axios.post('employees/add-to-non-main-organizational-unit', { ...obj })
            .then(res => {
                toast('Uspješno ste dodali novo zaposlenje.');
                this.setState({ addNewWorkload: false });
                this.getEmployments();
            })
            .catch(err => {
                if (err.response.data === 'Employee is already added to this organizational unit!') {
                    toast('Angažman za ovu OJ već postoji.');
                } else if (err.response.data === 'More than one oue found!') {
                    toast('Angažman za ovu OJ već postoji.');
                } else {
                    toast('Došlo je do greške! Angažman nije dodat.');
                }
            });
    }
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        const {
            employee, person, data, employment, otherEmployment, editOtherEmployment
        } = this.state;

        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        if (this.state.redirect) return <Redirect push to={{ pathname: '/nastavno-i-naučno-istraživačko-osoblje', state: { activeIndex: 1 } }} />;
        return (
            <div >

                {/* <Tab */}
                {/*    panes={panes} */}
                {/*    menu={{ */}
                {/*        secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true */}
                {/*    }} */}
                {/*    grid={{ paneWidth: 13, tabWidth: 3 }} */}
                {/* /> */}
                {localStorage.getItem('activeRole').substr(0, 18) !== 'HR admin: Rektorat' && <Message>
                    <Header as="h5"> *Provjerite da li ste unijeli pozicije. Prikaz pozicija dobijete klikom na sljedeću ikonicu u tabeli &nbsp;&nbsp;
                        <Icon.Group>
                            <Icon name="list ui" color="blue" basic="true" />
                            <Icon size="large" corner="bottom right" name="mouse pointer" />
                        </Icon.Group>.
                    </Header>
                </Message>}
                <Grid columns={2}>

                    <Grid.Column>
                        <Divider horizontal>
                            <Header as="h4"> Zaposlenje na matičnoj OJ</Header>
                        </Divider>
                        {this.state.showPositionsMain &&
                        <div>
                            <Positions
                                employment={this.state.employment}
                                close={() => this.setState({ showPositionsMain: false })}
                            />
                            <br /></div>
                        }

                        {data.filter(el => el.main).length ?
                            <div>


                                <Table celled selectable compact size="small">
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan="2">Organizaciona jedinica</Table.HeaderCell>
                                            <Table.HeaderCell>Početak angažmana</Table.HeaderCell>
                                            <Table.HeaderCell>Prestanak angažmana</Table.HeaderCell>
                                            <Table.HeaderCell>Radno vrijeme (%)</Table.HeaderCell>
                                            <Table.HeaderCell />
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body> {data.filter(el => el.main).map((el, index) =>
                                        (<Table.Row key={index} >

                                            <Table.Cell verticalAlign="middle" colSpan="2">
                                                {el.organizationalUnit.name}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >
                                                {employment === index ?
                                                    <Form>
                                                        <Form.Field>
                                                            <DateTimePicker
                                                                format="D. M. YYYY."
                                                                time={false}
                                                                onChange={this.handleDateChange.bind(null, 'dateStart')}
                                                                value={this.state.dateStart ? new Date(this.state.dateStart) : this.state.dateStart}
                                                            />
                                                        </Form.Field>
                                                    </Form>
                                                    : el.dateStart && moment(el.dateStart).format('D. M. YYYY.')
                                                }
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >
                                                {employment === index ?
                                                    <Form>
                                                        <Form.Field>
                                                            <DateTimePicker
                                                                format="D. M. YYYY."
                                                                time={false}
                                                                onChange={this.handleDateChange.bind(null, 'dateEnd')}
                                                                value={this.state.dateEnd ? new Date(this.state.dateEnd) : this.state.dateEnd}
                                                            />
                                                        </Form.Field>
                                                    </Form>
                                                    : el.dateEnd && <Fragment>
                                                        {moment(el.dateEnd).format('D. M. YYYY.')}
                                                        <span style={{ float: 'right' }}> {moment(el.dateEnd) <= moment(now()) && <Label prompt size="mini" color="red" basic> <Icon name="attention" /> Isteklo</Label>}</span>

                                                    </Fragment>
                                                }
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >
                                                {employment === index ?
                                                    <Form>
                                                        <input
                                                            value={this.state.workTime}
                                                            onChange={(e) => this.setState({ workTime: e.target.value })}
                                                            name="workTime"
                                                            type="number"
                                                            placeholder="Unesite radno vrijeme u postotcima"
                                                        />
                                                    </Form>
                                                    : el.workTime}
                                            </Table.Cell>
                                            <Table.Cell textAlign="center" verticalAlign="middle">
                                                {/* <Button color='green' basic='true' onClick={()=> this.setState({employment: index, editEmployment: true, showPositions: false})}> Izmjena</Button> */}

                                                {((this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && this.state.editEmployment) ?
                                                    <div>
                                                        <Button
                                                            compact
                                                            onClick={this.editEmployment}
                                                            circular
                                                            color="blue"
                                                            icon="check"
                                                            size="small"
                                                        />
                                                        <Button
                                                            onClick={() => this.setState({
                                                                optLock: null, id: null, orgUnit: null, employment: null, editEmployment: false, dateStart: null, dateEnd: null, workTime: null
                                                            })}
                                                            circular
                                                            compact
                                                            icon="close"
                                                            size="small"
                                                            basic="true"
                                                            color="blue"
                                                        />
                                                    </div>
                                                    : (this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') &&
                                                        <Popup
                                                            content="Izmjena"
                                                            position="top center"
                                                            trigger={<Button
                                                                onClick={() => this.setState({
                                                                    showPositionsMain: false,
                                                                    optLock: el.optLock,
                                                                    id: el.id,
                                                                    orgUnit: el.organizationalUnit.id,
                                                                    employment: index,
                                                                    editEmployment: true,
                                                                    dateStart: el.dateStart,
                                                                    dateEnd: el.dateEnd,
                                                                    workTime: el.workTime
                                                                })}
                                                                basic="true"
                                                                color="green"
                                                                circular
                                                                compact
                                                                icon="pencil"
                                                                size="small"
                                                            />}
                                                        />}

                                                {!this.state.editEmployment &&
                                                    <Popup
                                                        content="Pozicije"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                icon="list ui"
                                                                size="small"
                                                                basic="true"
                                                                color="blue"
                                                                circular
                                                                compact
                                                                onClick={() => this.setState({
                                                                    showPositionsMain: false, showPositions: false, editEmployment: false
                                                                }, () => this.getPositionsMain(el))}
                                                            />}
                                                    />}

                                            </Table.Cell>
                                        </Table.Row>
                                        ))}
                                    </Table.Body>
                                </Table></div>
                            : 'Nema informacija o matičnom zaposlenju.'}

                    </Grid.Column>
                    <Grid.Column>
                        <Divider horizontal>
                            <Header as="h4"> Angažmani na ostalim OJ</Header>

                        </Divider>
                        { (JSON.parse(localStorage.getItem('employee')).employeeType._key === 'nastavno osoblje' && data.filter(el => !el.main).length) ?
                            <div>
                                {this.state.showPositions && <div>
                                    <Positions
                                        employment={otherEmployment}
                                        close={() => this.setState({ showPositions: false })}
                                    />
                                    <br />
                                </div>}

                                {data.filter(el => !el.main).length ? <Table celled selectable compact size="small">
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan="2">Organizaciona jedinica</Table.HeaderCell>
                                            <Table.HeaderCell>Početak angažmana</Table.HeaderCell>
                                            <Table.HeaderCell>Prestanak angažmana</Table.HeaderCell>
                                            <Table.HeaderCell>Radno vrijeme (%)</Table.HeaderCell>
                                            <Table.HeaderCell textAlign="center" verticalAlign="middle">
                                                {this.state.main && <Button
                                                    // disabled={this.state.currentAcademicYear !== this.state.academicYearForReport}
                                                    icon="add"
                                                    size="tiny"
                                                    basic="true"
                                                    color="blue"
                                                    circular
                                                    onClick={() => this.setState({
                                                        addNewWorkload: true,
                                                        editMode: null
                                                    })}
                                                />}
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {this.state.addNewWorkload &&
                                            <Table.Row>
                                                <Table.Cell colSpan={2} verticalAlign="middle" >
                                                    <Form.Field required error={this.state.orgUnitErr}>
                                                        <Form.Dropdown
                                                            selection
                                                            placeholder="Odaberite fakultet"
                                                            value={this.state.orgUnit}
                                                            onChange={this.handleInputChange}
                                                            name="orgUnit"
                                                            options={this.state.orgUnits.filter(el => el.text !== 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet' && el.text !== 'Testni fakultet')}
                                                            search
                                                            fluid
                                                        />
                                                    </Form.Field>
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" >

                                                    <Form>
                                                        <Form.Field>
                                                            <DateTimePicker
                                                                format="D. M. YYYY."
                                                                time={false}
                                                                onChange={this.handleDateChange.bind(null, 'dateStart')}
                                                                value={this.state.dateStart ? new Date(this.state.dateStart) : this.state.dateStart}
                                                            />
                                                        </Form.Field>
                                                    </Form>

                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" >

                                                    <Form>
                                                        <Form.Field>
                                                            <DateTimePicker
                                                                format="D. M. YYYY."
                                                                time={false}
                                                                onChange={this.handleDateChange.bind(null, 'dateEnd')}
                                                                value={this.state.dateEnd ? new Date(this.state.dateEnd) : this.state.dateEnd}
                                                            />
                                                        </Form.Field>
                                                    </Form>

                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" >

                                                    <Form>
                                                        <input
                                                            value={this.state.workTime}
                                                            onChange={(e) => this.setState({ workTime: e.target.value })}
                                                            name="workTime"
                                                            type="number"
                                                            placeholder="Unesite radno vrijeme u postotcima"
                                                        />
                                                    </Form>

                                                </Table.Cell>

                                                <Table.Cell verticalAlign="middle" textAlign="center">

                                                    <Button
                                                        size="small"
                                                        color="blue"
                                                        icon="check"
                                                        circular
                                                        onClick={() => this.addNewEmployment()}
                                                    />
                                                    <Button
                                                        size="small"
                                                        basic="true"
                                                        color="blue"
                                                        icon="close"
                                                        circular
                                                        onClick={() => this.setState({
                                                            addNewWorkload: false,
                                                            exerciseNumber: null,
                                                            lectureNumber: null,
                                                            comment: null,
                                                            course: null
                                                        })}
                                                    />

                                                </Table.Cell>
                                            </Table.Row>}

                                        {data.filter(el => !el.main).map((el, index) =>
                                            (<Fragment>

                                                <Table.Row key={index} >

                                                    <Table.Cell verticalAlign="middle" colSpan="2">
                                                        {el.organizationalUnit.name}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" >
                                                        {otherEmployment === index ?
                                                            <Form>
                                                                <Form.Field>
                                                                    <DateTimePicker
                                                                        format="D. M. YYYY."
                                                                        time={false}
                                                                        onChange={this.handleDateChange.bind(null, 'dateStart')}
                                                                        value={this.state.dateStart ? new Date(this.state.dateStart) : this.state.dateStart}
                                                                    />
                                                                </Form.Field>
                                                            </Form>
                                                            : el.dateStart && moment(el.dateStart).format('D. M. YYYY.')
                                                        }
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" >
                                                        {otherEmployment === index ?
                                                            <Form>
                                                                <Form.Field>
                                                                    <DateTimePicker
                                                                        format="D. M. YYYY."
                                                                        time={false}
                                                                        onChange={this.handleDateChange.bind(null, 'dateEnd')}
                                                                        value={this.state.dateEnd ? new Date(this.state.dateEnd) : this.state.dateEnd}
                                                                    />
                                                                </Form.Field>
                                                            </Form>
                                                            : el.dateEnd && <Fragment>
                                                                {moment(el.dateEnd).format('D. M. YYYY.')}
                                                                <span style={{ float: 'right' }}> {moment(el.dateEnd) <= moment(now()) && <Label prompt size="mini" color="red" basic> <Icon name="attention" />Isteklo</Label>}</span>

                                                            </Fragment>

                                                        }
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" >
                                                        {otherEmployment === index ?
                                                            <Form>
                                                                <input
                                                                    value={this.state.workTime}
                                                                    onChange={(e) => this.setState({ workTime: e.target.value })}
                                                                    name="workTime"
                                                                    type="number"
                                                                    placeholder="Unesite radno vrijeme u postotcima"
                                                                />
                                                            </Form>
                                                            : el.workTime}
                                                    </Table.Cell>
                                                    <Table.Cell textAlign="center" verticalAlign="middle" >
                                                        {((this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') && editOtherEmployment) ? <div>
                                                            <Button
                                                                onClick={this.editEmployment}
                                                                circular
                                                                compact
                                                                color="blue"
                                                                icon="check"
                                                                size="small"
                                                            />
                                                            <Button
                                                                onClick={() => this.setState({
                                                                    optLock: null, id: null, orgUnit: null, otherEmployment: null, editOtherEmployment: false, dateStart: null, dateEnd: null, workTime: null
                                                                })}
                                                                circular
                                                                compact
                                                                icon="close"
                                                                size="small"
                                                                basic="true"
                                                                color="blue"
                                                            />

                                                        </div>
                                                            : (this.state.main || localStorage.getItem('associate') === 'true' && localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:') &&

                                                        this.state.mainConfirmation ?
                                                                this.state.currentEl === el ? <Header as="h6" textAlign="center" floated="right">
                                                                    <h4>Jeste li sigurni?</h4>
                                                                    <h6><i>Nakon što označite novu matičnu OJ više nećete moći da vršite izmjenu podataka ovom zaposleniku.</i></h6>
                                                                    <Button.Group>
                                                                        <Button
                                                                            basic="true"
                                                                            color="blue"
                                                                            onClick={() => this.changeMain(el.organizationalUnit.id)}
                                                                        > DA</Button>
                                                                        <Button
                                                                            basic="true"
                                                                            color="red"
                                                                            onClick={() => { this.setState({ mainConfirmation: false }); }}
                                                                        >  NE

                                                                        </Button>
                                                                    </Button.Group>

                                                                </Header> : null
                                                                : <Fragment>
                                                                    {(this.state.main || localStorage.getItem('associate') === 'true' ) && (localStorage.getItem('activeRole').substr(0, 18) !== 'HR admin: Rektorat') &&  <Button
                                                                        onClick={() => this.setState({
                                                                            showPositions: false,
                                                                            optLock: el.optLock,
                                                                            id: el.id,
                                                                            orgUnit: el.organizationalUnit.id,
                                                                            otherEmployment: index,
                                                                            editOtherEmployment: true,
                                                                            dateStart: el.dateStart,
                                                                            dateEnd: el.dateEnd,
                                                                            workTime: el.workTime
                                                                        })}
                                                                        basic="true"
                                                                        color="green"
                                                                        circular
                                                                        compact
                                                                        icon="pencil"
                                                                        size="small"
                                                                    />}
                                                                    {this.state.main && <Popup
                                                                        content="Označi kao matičnu OJ"
                                                                        position="top center"
                                                                        trigger={
                                                                            <Button
                                                                                onClick={() => { this.setState({ currentEl: el, mainConfirmation: true }); }}
                                                                                basic="true"
                                                                                color="red"
                                                                                circular
                                                                                compact
                                                                                icon="exchange"
                                                                                size="small"
                                                                            />}
                                                                    />}
                                                                </Fragment>
                                                        }

                                                        {!this.state.mainConfirmation && !editOtherEmployment && <Popup
                                                            content="Pozicije"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    icon="list ui"
                                                                    size="small"
                                                                    basic="true"
                                                                    color="blue"
                                                                    circular
                                                                    compact
                                                                    onClick={() => this.setState({
                                                                        showPositions: false, showPositionsMain: false, editOtherEmployment: false
                                                                    }, () => this.getPositions(el))}
                                                                />}
                                                        />}
                                                    </Table.Cell>
                                                </Table.Row></Fragment>
                                            ))}
                                    </Table.Body>
                                </Table> :
                                    'Nema angažmana na drugim organizacionim jedinicama.'
                                }

                            </div> :

                            <Table celled selectable compact size="small">
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan="2">Organizaciona jedinica</Table.HeaderCell>
                                        <Table.HeaderCell>Početak angažmana</Table.HeaderCell>
                                        <Table.HeaderCell>Prestanak angažmana</Table.HeaderCell>
                                        <Table.HeaderCell>Radno vrijeme (%)</Table.HeaderCell>
                                        <Table.HeaderCell verticalAlign="middle" textAlign="center">
                                            {this.state.main && <Button
                                                // disabled={this.state.currentAcademicYear !== this.state.academicYearForReport}
                                                icon="add"
                                                size="tiny"
                                                basic="true"
                                                color="blue"
                                                circular
                                                onClick={() => this.setState({ addNewWorkload: true, editMode: null })}
                                            />}
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>

                                    {!this.state.addNewWorkload ? <Table.Row ><Table.Cell colSpan={6}>Nema angažmana na drugim organizacionim jedinicama.</Table.Cell></Table.Row>
                                        : <Table.Row>
                                            <Table.Cell colSpan={2} verticalAlign="middle" >
                                                <Form.Field required error={this.state.orgUnitErr}>
                                                    <Form.Dropdown
                                                        selection
                                                        placeholder="Odaberite fakultet"
                                                        value={this.state.orgUnit}
                                                        onChange={this.handleInputChange}
                                                        name="orgUnit"
                                                        options={this.state.orgUnits.filter(el => el.text !== 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet' && el.text !== 'Testni fakultet')}
                                                        search
                                                        fluid
                                                    />
                                                </Form.Field>
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >

                                                <Form>
                                                    <Form.Field>
                                                        <DateTimePicker
                                                            format="D. M. YYYY."
                                                            time={false}
                                                            onChange={this.handleDateChange.bind(null, 'dateStart')}
                                                            value={this.state.dateStart ? new Date(this.state.dateStart) : this.state.dateStart}
                                                        />
                                                    </Form.Field>
                                                </Form>

                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >

                                                <Form>
                                                    <Form.Field>
                                                        <DateTimePicker
                                                            format="D. M. YYYY."
                                                            time={false}
                                                            onChange={this.handleDateChange.bind(null, 'dateEnd')}
                                                            value={this.state.dateEnd ? new Date(this.state.dateEnd) : this.state.dateEnd}
                                                        />
                                                    </Form.Field>
                                                </Form>

                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >

                                                <Form>
                                                    <input
                                                        value={this.state.workTime}
                                                        onChange={(e) => this.setState({ workTime: e.target.value })}
                                                        name="workTime"
                                                        type="number"
                                                        placeholder="Unesite radno vrijeme u postotcima"
                                                    />
                                                </Form>

                                            </Table.Cell>

                                            <Table.Cell verticalAlign="middle" textAlign="center">

                                                <Button
                                                    size="small"
                                                    color="blue"
                                                    icon="check"
                                                    circular
                                                    onClick={() => this.addNewEmployment()}
                                                />
                                                <Button
                                                    size="small"
                                                    basic="true"
                                                    color="blue"
                                                    icon="close"
                                                    circular
                                                    onClick={() => this.setState({
                                                        addNewWorkload: false,
                                                        exerciseNumber: null,
                                                        lectureNumber: null,
                                                        comment: null,
                                                        course: null
                                                    })}
                                                />

                                            </Table.Cell>
                                        </Table.Row>}

                                </Table.Body>
                            </Table>

                        }
                    </Grid.Column>
                </Grid>


                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/profile/Employee/Employment.js